import VideoCover from "../assets/serene-images/serene-construction.avif";

const generateGallery = (folderPath, count) => {
  return Array.from({ length: count }, (_, i) => `${folderPath}/${i + 1}.JPG`);
};

export const sereneFeatures = [
  {
    title: "Construction Progress",
    cover: "/Serene-Construction-Progress/Images/Serene-May/1.JPG",
    type: "folder",
    folders: [
      {
        title: "May 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-May/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-May", 16),
      },
      {
        title: "April 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-April/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-April", 15),
      },
      {
        title: "March 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-March/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-March", 15),
      },
      {
        title: "February 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Feb/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Feb", 8),
      },
      {
        title: "January 2026 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Jan/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Jan", 6),
      },
      {
        title: "December 2025 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-Dec/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-Dec", 35),
      },
      {
        title: "November 2025 Update",
        cover: "/Serene-Construction-Progress/Images/Serene-November/1.JPG",
        gallery: generateGallery("/Serene-Construction-Progress/Images/Serene-November", 3),
      }
    ]
  },
  {
    title: "Video Gallery",
    cover: VideoCover,
    type: "folder",
    folders: [
      {
        title: "May 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-May-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-May.mp4", title: "MAY 2026 UPDATE" }
        ]
      },
      {
        title: "April 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-April-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-April.mp4", title: "APRIL 2026 UPDATE" }
        ]
      },
      {
        title: "March 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-March-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-March.mp4", title: "MARCH 2026 UPDATE" }
        ]
      },
      {
        title: "February 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-February-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-February.mp4", title: "FEBRUARY 2026 UPDATE" }
        ],
      },
      {
        title: "January 2026 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-January-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-January.mp4", title: "JANUARY 2026 UPDATE" }
        ],
      },
      {
        title: "December 2025 Update",
        cover: "/Serene-Construction-Progress/Videos/Serene-December-thumb.png",
        gallery: [
          { type: "video", src: "/Serene-Construction-Progress/Videos/Serene-December.mp4", title: "DECEMBER 2025 UPDATE" }
        ]
      }
    ]
  },
];
